// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zai-hero-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 36px;
  align-items: center;
}
.zai-hero-container .Error-handler {
  margin: 0;
}
.zai-hero-container .zai-hero-form-box {
  display: flex;
  flex-direction: column;
}
.zai-hero-container .zai-hero-form-box .zai-hero-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 760px;
  height: 60px;
  padding: 12px;
  gap: 5px;
  border-radius: 16px;
  background-color: var(--base_color2);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(241, 244, 250, 0.1);
}
.zai-hero-container .zai-hero-form-box .zai-hero-form .zai-hero-form-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
}
.zai-hero-container .zai-hero-form-box .zai-hero-form .zai-hero-form-input {
  width: 100%;
  height: 100%;
  margin-right: 6px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--color_neutral_500);
  border: 0;
}
.zai-hero-container .zai-hero-form-box .zai-hero-form .zai-hero-form-input::placeholder {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--color_neutral_500);
}
.zai-hero-container .zai-hero-form-box .zai-hero-form .zai-hero-form-button-send {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: linear-gradient(136.74deg, #7723ff 5.56%, #5f3d85 97.31%);
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.0588235294);
}
.zai-hero-container .zai-hero-pre-prompt-sketons-list {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  min-height: 108px;
  width: 760px;
  gap: 16px;
}
.zai-hero-container .zai-hero-pre-prompt-sketons-list .zai-hero-pre-prompt-sketons-list-item {
  display: flex;
  list-style: none;
}
.zai-hero-container .zai-hero-pre-prompt-list {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  gap: 16px;
  min-height: 108px;
  width: 100%;
  max-width: 960px;
}
.zai-hero-container .zai-hero-pre-prompt-list .zai-hero-pre-prompt-list-item {
  display: flex;
  list-style: none;
}`, "",{"version":3,"sources":["webpack://./src/modules/zai/zai-hero/zai-hero.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AACF;AACE;EACE,SAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,oCAAA;EACA,+CAAA;EACA,0CAAA;AAAN;AACM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AACR;AACM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,+BAAA;EACA,SAAA;AACR;AAAQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,+BAAA;AAEV;AACM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qEAAA;EACA,wDAAA;AACR;AAIE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,SAAA;AAFJ;AAII;EACE,aAAA;EACA,gBAAA;AAFN;AAME;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AAJJ;AAKI;EACE,aAAA;EACA,gBAAA;AAHN","sourcesContent":[".zai-hero-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 36px;\n  align-items: center;\n\n  .Error-handler {\n    margin: 0;\n  }\n\n  .zai-hero-form-box {\n    display: flex;\n    flex-direction: column;\n\n    .zai-hero-form {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 760px;\n      height: 60px;\n      padding: 12px;\n      gap: 5px;\n      border-radius: 16px;\n      background-color: var(--base_color2);\n      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);\n      border: 1px solid rgba(241, 244, 250, 0.1);\n      .zai-hero-form-icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        width: 32px;\n        height: 32px;\n      }\n      .zai-hero-form-input {\n        width: 100%;\n        height: 100%;\n        margin-right: 6px;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        letter-spacing: 0;\n        color: var(--color_neutral_500);\n        border: 0;\n        &::placeholder {\n          font-weight: 400;\n          font-size: 14px;\n          line-height: 20px;\n          letter-spacing: 0;\n          color: var(--color_neutral_500);\n        }\n      }\n      .zai-hero-form-button-send {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        width: 36px;\n        height: 36px;\n        border-radius: 6px;\n        background: linear-gradient(136.74deg, #7723ff 5.56%, #5f3d85 97.31%);\n        box-shadow: 0px 1px 10px 0px #0000000f;\n      }\n    }\n  }\n\n  .zai-hero-pre-prompt-sketons-list {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    margin: 0;\n    padding: 0;\n    min-height: 108px;\n    width: 760px;\n    gap: 16px;\n\n    .zai-hero-pre-prompt-sketons-list-item {\n      display: flex;\n      list-style: none;\n    }\n  }\n\n  .zai-hero-pre-prompt-list {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    margin: 0;\n    padding: 0;\n    gap: 16px;\n    min-height: 108px;\n    width: 100%;\n    max-width: 960px;\n    .zai-hero-pre-prompt-list-item {\n      display: flex;\n      list-style: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
